// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"521":"02593beb","560":"cfda9280","561":"9710c7ef","878":"81ece0eb"}[chunkId] + ".chunk.js";
};